import { Pipe, PipeTransform } from '@angular/core';
import { Vacation } from '@thehubz/client/data-access-api';

@Pipe({
  name: 'canEditVacation',
})
export class CanEditVacationPipe implements PipeTransform {
  /**
   * Vacations can be edited if they are not in the past
   */
  transform(vacation: Vacation): boolean {
    if (!vacation.to) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endDate = new Date(vacation.to);
    endDate.setHours(0, 0, 0, 0);
    return endDate >= today;
  }
}
